module.exports = __webpack_public_path__ + "img/voting-down.68b3dbe8.svg";